import { SET_TOOLBAR } from '@Types/actionTypes';

export function setToolbar(id){

  return {
    type : SET_TOOLBAR,
    payload : id
  }
}
